/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Group_Visibility_FailedInputs */

const vi_shop_group_visibility_failed = /** @type {(inputs: Shop_Group_Visibility_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không đổi được hiển thị của nhóm.`)
};

/**

* @param {Shop_Group_Visibility_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_group_visibility_failed = /** @type {((inputs?: Shop_Group_Visibility_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Group_Visibility_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_group_visibility_failed(inputs)
});